<button
    type="button"
    class="device-card"
    (click)="select()"
    [ngClass]="{ '-selected': selected === device.name }"
>
    <img
        [src]="device.icon"
        alt=""
        role="presentation"
    />
    <span class="device-name">{{ device.displayName }}</span>
</button>
